import { Link } from 'react-router-dom';
import { BrandHeader } from '../components/BrandHeader';
import { content } from '../content/content';

export function NotFoundPage() {
  const copy = content.es;

  return (
    <main className="thanksPage" lang="es">
      <BrandHeader language="es" />
      <section className="thanksPanel" aria-labelledby="not-found-title">
        <h1 id="not-found-title">{copy.notFoundTitle}</h1>
        <p>{copy.notFoundText}</p>
        <Link className="primaryButton" to="/">
          {copy.backHome}
        </Link>
      </section>
    </main>
  );
}
